module.exports = ".ellipsis-item {\n  width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  margin: -4px 2px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/documents/documents.component.css
// module id = ./src/app/shared/documents/documents.component.css
// module chunks = main